/**
 * api/ops.ts —— 运维（§五 5.12）
 *
 * ⚠ /api/health 是【公开接口，不需要登录】：pm2 / Nginx / 人工排障都要能直接打。
 *   骨架期它还有第二个用途——「前端起来了但后端没起」的自助排查，见 main.ts 的 boot 兜底。
 */
import { get } from './client.js';

export interface Health {
  ok: boolean;
  env: string;
  /** 服务端「现在」，用于核对 CVM 时区是否为北京时间——时区错了全站日差都会错 */
  now: string;
  today: string;
  db: boolean;
  dbError: string | null;
  cos: 'ready' | 'not-configured';
}

export const health = () => get<Health>('/api/health');

/** 演示数据残留计数。⚠ 09-01 清数据后每行 cnt 必须为 0，是上线前置断言 */
export const demoResidue = () => get<Array<{ tbl: string; cnt: number }>>('/api/admin/demo-residue');
